import { render, staticRenderFns } from "./addOffender.vue?vue&type=template&id=ce58b472&scoped=true"
import script from "./addOffender.vue?vue&type=script&lang=js"
export * from "./addOffender.vue?vue&type=script&lang=js"
import style0 from "./addOffender.vue?vue&type=style&index=0&id=ce58b472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce58b472",
  null
  
)

export default component.exports